// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content_pIJBB"};